import CommunicationSimulator from './communication_simulator';
import Communicator from 'models/communicator';
import Factory from 'factories/all';

export default class IncomingSmsSimulator extends CommunicationSimulator {
  constructor({ orgId, publisher, services }, database) {
    super({ attribute: 'incomingSms', createItem: createSmsItem, orgId, publisher, services }, database);
  }

  _createRoutingItem(attrs) {
    return Factory.build('RoutingItemForIncomingSMS', this._getRoutingItemAttrs(attrs));
  }
}

function createSmsItem(incomingSms) {
  return Factory.build('SmsMessageItem', {
    initiator: {
      type: Communicator.CUSTOMER,
      id: incomingSms.customerId,
    },
    content: incomingSms.content,
  });
}



// WEBPACK FOOTER //
// ./src/scripts/infrastructure/backends/communication_simulation_service/incoming_sms_simulator.js